<template>
  <div>
    <b-table :fields="fields" :items="items">
      <template #head(checkbox)="data">
        <b-form-checkbox />
      </template>
      <template #cell(checkbox)="data">
        <b-form-checkbox />
      </template>


      <template #cell(percent)="{value}">
        <b-badge class="d-inline-flex align-items-center" v-if="value">
          <b-icon-percent/>
          <span class="ml-2">درصدی</span>
        </b-badge>
        <b-badge class="d-inline-flex align-items-center" v-else>
          <b-icon-cash/>
          <span class="ml-2">پولی</span>
        </b-badge>
      </template>

      <template #cell(actions)="data">
        <b-button size="sm" class="mr-1">
          <b-icon-pencil />
        </b-button>
        <b-button size="sm" class="mr-1">
          <b-icon-trash />
        </b-button>
      </template>


    </b-table>

    <b-row>
      <b-col sm="5" md="3" class="my-1">
        <b-form-group
          label="تعداد در صفحه"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="5"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="4" class="offset-lg-5">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="md"
          first-number
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ListTable",
  data() {
    return {
      test: false,
      perPage: 15,
      pageOptions: [15, 30, 60, 100],
      currentPage: 1,
      isSelectedAll: false,
      fields: [
        { key: "checkbox", label: "" },
        {
          key: "id",
          label: "شناسه",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "title",
          label: "عنوان"
        },
        {
          key: "percent",
          label: "نوع تخفیف",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "amount",
          label: "مقدار تخفیف",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "start_at",
          label: "تاریخ شروع",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "end_at",
          label: "تاریخ پایان",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "actions",
          label: "عملیات"
        }
      ],
      items: [
        {
          id: 1,
          title: "test",
          percent: false,
          amount : "25,000 تومان",
          start_at: "1234/34/12s",
          end_at: "1234/34/12s"
        },
        {
          id: 2,
          title: "test 2",
          percent: true,
          amount : "23%",
          start_at: "1234/34/12s",
          end_at: "1234/34/12s"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
